import { ReactNode } from "react";
import { useTokenInitializer } from "src/hooks";
import { useUrlParamsContext } from "src/contexts";
import { isCxmExchange } from "src/api";
import { Loader, CxmBootSurface } from "src/components";

interface RouteGuardProps {
  children: ReactNode;
}

const RouteGuard: React.FC<RouteGuardProps> = ({ children }) => {
  const { currencyId, paymentRouteId, apiUrl, storedDataKey, exchange } = useUrlParamsContext();
  const { accessToken } = useTokenInitializer(storedDataKey);

  const requiredUrlParamsPresent = currencyId && paymentRouteId && apiUrl;

  if (!requiredUrlParamsPresent || !accessToken) {
    // A CXM tenant has no Alfred, so it must not show Alfred's spinner even
    // for the token exchange; it gets a plain themed surface and the branded
    // pane takes over as soon as the page mounts.
    return isCxmExchange(exchange) ? <CxmBootSurface /> : <Loader />;
  }

  return <>{children}</>;
};

export default RouteGuard;
